import React, { ComponentProps } from 'react';
import classNames from 'classnames';
import Media from '@/components/ui/Media/Media';

import styles from './PromoBanner.module.css';

type PromoBannerProps = Pick<ComponentProps<typeof Media>, 'media_url' | 'priority'> & {};

export default function PromoBanner(
  {
    children,
    media_url,
    priority,
  }: React.PropsWithChildren<PromoBannerProps>,
): React.ReactElement {
  return (
    <div className={classNames(
      styles['promo-banner'],
    )}
    >
      <Media
        autoplay
        priority={priority}
        media_url={media_url}
        className={styles['promo-banner__video-fallback']}
      />
      <div className={styles['promo-banner__background-backdrop']}>
        {children}
      </div>
    </div>
  );
}
